'use strict';

var React = require('react');

const FocusManagerContext = /*#__PURE__*/React.createContext(undefined);

exports.FocusManagerContext = FocusManagerContext;
